export const colors = {
  // colorName: {
  //   50: '',   // lightest
  //   ...
  //   500: '',  // main
  //   ...
  //   900: '',  // darkest
  // },

  teal: {
    500: '#03DAC6',
    700: '#018786',
  },

  black: {
    25: '#FAFAFA',
    50: '#F6F6F6',
    100: '#E7E7E7',
    200: '#D1D1D1',
    300: '#B0B0B0',
    //   400: '#888888',
    //   500: '#6D6D6D',
    600: '#5D5D5D',
    700: '#4F4F4F',
    800: '#454545',
    850: '#333333',
    900: '#262626',
    950: '#1A1A1A',
  },

  green: {
    50: '#EFFFE0',
    //   100: '#EFFFC5',
    200: '#DEFF92',
    300: '#C7FF53',
    400: '#ADFB20',
    500: '#84D300',
    600: '#6CB500',
    700: '#528902',
    800: '#426C08',
    900: '#395B0C',
    //   950: '#1B3300',
  },

  gray: {
    //   25:  '#F9FAFC',
    50: '#F4F5F7',
    100: '#EDEEF1',
    200: '#D6DAE1',
    300: '#B2BAC7',
    400: '#8996A7',
    500: '#6A798D',
    //   600: '#556174',
    700: '#46505E',
    //   800: '#3C4450',
    //   900: '#353B45',
    950: '#23272E',
  },

  grayTrue: {
    //   25:  '#FCFCFC',
    50: '#F7F7F7',
    //   100: '#F5F5F5',
    //   200: '#E5E5E5',
    //   300: '#D6D6D6',
    //   400: '#A3A3A3',
    //   500: '#737373',
    //   600: '#525252',
    //   700: '#424242',
    //   800: '#292929',
    850: '#232323',
    900: '#141414',
    //   950: '#0F0F0F',
  },

  red: {
    //  25:  '#FFFBFA',
    50: '#FEF3F2',
    // 100: '#FEE4E2',
    200: '#FECDCA',
    300: '#FDA29B',
    400: '#F97066',
    500: '#F04438',
    600: '#D92D20',
    700: '#B42318',
    // 800: '#912018',
    // 900: '#7A271A',
    // 950: '#55160C',
  },

  warning: {
    //   25:  '#FFFCF5',
    50: '#FFFAEB',
    //   100: '#FEF0C7',
    200: '#FEDF89',
    //   300: '#FEC84B',
    400: '#FDB022',
    //   500: '#F79009',
    600: '#DC6803',
    700: '#B54708',
    //   800: '#93370D',
    //   900: '#7A2E0E',
    //   950: '#4E1D09',
  },

  success: {
    //   25:  '#F6FEF9',
    50: '#ECFDF3',
    //   100: '#DCFAE6',
    200: '#ABEFC6',
    //   300: '#75E0A7',
    400: '#47CD89',
    //   500: '#17B26A',
    600: '#079455',
    700: '#067647',
    //   800: '#085D3A',
    //   900: '#074D31',
    //   950: '#053321',
  },

  blue: {
    50: '#EFF8FF',
    200: '#B2DDFF',
    700: '#175CD3',
  },

  common: {
    white: '#FFFFFF',
    black: '#000000',
  },
};
